export default {"src":"/_next/static/media/fundraising.d3fb5f40.svg","height":68,"width":57};